import style from "./GDPRConsent.module.css";
import Checkbox from "../Checkbox/Checkbox";

interface Option {
  label: string;
  value: number;
}
interface GDPRConsentProps {
  name: string;
  options: Option[];
}
const GDPRConsent: React.FC<GDPRConsentProps> = ({ name, options }) => {
  return (
    <div className={style.container}>
      <div className={style.title}>GDPR and data privacy consent</div>
      <div className={style.content}>
        <div className={style.consentContainer}>
          <Checkbox
            required
            label={
              <span style={{ fontFamily: "Inter" }}>
                I have read the{" "}
                <a
                  style={{ color: "rgb(29, 78, 255)" }}
                  href="https://www.shapr3d.com/recruitment-privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Recruitment Privacy Policy
                </a>{" "}
                and Shapr3D has my consent to collect, store and process my data
                for the purpose of considering me for employment.
              </span>
            }
            name={name}
          ></Checkbox>
        </div>
        <div style={{ fontSize: "14px" }}>
          Of course, if you have any questions about how we are going to use
          your data once you submit your application, email us at:{" "}
          <a
            href="mailto:interview@shapr3d.com"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#1d4eff" }}
          >
            interview@shapr3d.com
          </a>
          .
        </div>

        <div style={{ fontSize: "14px" }}>
          Good luck in the process! :) Shapr3D Recruitment Team
        </div>
      </div>
    </div>
  );
};

export default GDPRConsent;
